import { QUERY_PARAM_ROUTES } from '../../../utils/constants/QueryParamRoutes';

export const BASE_SEARCH_PATHNAME = QUERY_PARAM_ROUTES.SEARCH;
export const DEFAULT_REDIRECT = '/';
